<template>
  <slot name="header_close" />
  <div
    :class="[
      {
        'number-add-second-frame': isIndepend,
        'number-false': !settings.isValidNumber,
      },
    ]"
  >
    <div class="title">
      <span>{{ $t("dialog.add_number.title_modal") }} Viber</span>
    </div>
    <slot name="actions" />
    <div class="content">
      <integration-select
        parentClass="number-add-second-frame"
        :options="selectedOptions"
        filter="viber"
        readonly
      />
      <PhoneInput v-model:userNumber="newNumber" />
    </div>

    <ButtonConfirm class="confirm" @click="confirmDialog">{{
      $t("dialog.add_number.button")
    }}</ButtonConfirm>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import IntegrationSelect from "../../Recurring/IntegrationSelect.vue";
import ButtonConfirm from "../../Recurring/ButtonConfirm.vue";
import PhoneInput from "../../Recurring/PhoneInput.vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

const router = useRouter();
const { t: $t } = useI18n();
const store = useStore();

const newNumber = ref("");
const settings = reactive({
  isValidNumber: true,
});
const selectedOptions = ref({
  title: true,
});

defineProps({
  isIndepend: {
    type: Boolean,
    default: true,
  },
});

const confirmDialog = async () => {
  const isValidNumber =
    newNumber.value.length <= 13 && newNumber.value.length > 9;

  if (isValidNumber) {
    store.commit("closeDialog");

    store.commit("activation/SET_NUMBER", newNumber.value);
    store.commit("activation/SET_MESSENGER", "viber");

    const goToActivation = await store.dispatch("activation/addNumber");

    goToActivation &&
      router.push({
        name: "ActivationViber",
        params: { number: newNumber.value },
      });
  } else {
    settings.isValidNumber = isValidNumber;
  }
};

onMounted(() => {
  store.commit("activation/CLEAR_STATE");
});
</script>
<!-- wasn't scoped in style -->
<style lang="scss" scoped>
// !TODO: REFACTOR
.number-false {
  label {
    // background-color: black;
  }
}

.number-add-second-frame {
  padding: 20px 28px 42px;
  max-width: 750px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border-radius: 7px;
  background-color: white;
  text-align: center;
}

.title {
  text-align: center;
  font-family: Gilroy;
  font-weight: 500;
  text-transform: uppercase;
  color: var(--text-color);

  span {
    font-size: 20px;
  }
}

.content {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  text-align: left;
}

.confirm {
  margin-top: 16px;
}
</style>
